/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quickcreatelabel2Inputs */

const en_quickcreatelabel2 = /** @type {(inputs: Quickcreatelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new`)
};

const de_quickcreatelabel2 = /** @type {(inputs: Quickcreatelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu erstellen`)
};

/**
* | output |
* | --- |
* | "Create new" |
*
* @param {Quickcreatelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const quickcreatelabel2 = /** @type {((inputs?: Quickcreatelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickcreatelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quickcreatelabel2(inputs)
	return de_quickcreatelabel2(inputs)
});
export { quickcreatelabel2 as "quickCreateLabel" }